<!--分项能耗统计-->
<template>
	<div class="iEcanalysisBody">
		<div class="top">
			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="能耗类型">
					<el-select v-model="form.type" placeholder="请选择活动区域">
						<el-option label="水" value="水"></el-option>
						<el-option label="电" value="电"></el-option>
						<el-option label="气" value="气"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="日期类型">
					<el-radio-group v-model="form.dataType" size="small">
						<el-radio-button label="日"></el-radio-button>
						<el-radio-button label="周"></el-radio-button>
						<el-radio-button label="月"></el-radio-button>
						<el-radio-button label="年"></el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="时间">
					<el-date-picker v-model="form.dataTime" :type="dateType" :format="timeFormat" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
			</el-form>
		</div>
		<div class="center">
			<div class="center_div">
				<img :src="getImage('1yt.png')" />
				<div>
					<p>累计用{{form.type}}量</p>
					<p style="color: #ee9700;">{{countAmout}}{{unit}}</p>
				</div>
			</div>
			<div class="center_div">
				<img :src="getImage('2yt.png')" />
				<div>
					<p>折标煤</p>
					<p style="color: #ea5066;">{{getDiscount}}kgce</p>
				</div>
			</div>
			<div class="center_div">
				<img :src="getImage('6yt.png')" />
				<div>
					<p>与{{getTbType}}同比</p>
					<p style="color: #4cd382;">{{getCountTbAmout}}%</p>
				</div>
			</div>
			<div class="center_div">
				<img :src="getImage('4yt.png')" />
				<div>
					<p>单位面积耗电量</p>
					<p style="color: #d34cd1;">{{nowUnit.unitArea}}/{{getunitAreaAmount}}{{unit}}</p>
				</div>
			</div>
			<div class="center_div">
				<img :src="getImage('5yt.png')" />
				<div>
					<p>人均耗电量</p>
					<p style="color: #2edfff;">{{nowUnit.unitPeopleNumber}}/{{getPeopleAmount}}{{unit}}</p>
				</div>
			</div>
		</div>
		<!--分项用电能耗-->
		<div class="subtitle">
			<h1>分项能耗用电</h1></div>
		<div class="center2">
			<div class="center2_div" v-for="(item,key,index) in subAreausList">
				<div>
					<span>{{key}}</span>
					<span>同比</span>
				</div>
				<div>
					<span style="color: #2edfff;">{{item["value"]}}{{unit}}</span>
					<span>
						<img :src="getArrowImage(gettb(item['value'],item['tbValue']))" />
						{{gettb(item["value"],item["tbValue"])}}%
					</span>
				</div>
			</div>
		</div>
		<div class="bottom">
			<vchart ref="vchart1"></vchart>
		</div>
		<div class="bottom_table">
			<el-table :data="dataTable" max-height="240">
				<el-table-column prop="name" label="名称" width="150" fixed>
				</el-table-column>
				<el-table-column :prop="getProp(i)" :label="item" v-for="(item,i) in tableColumn" width="150">
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {
			vchart,
		},
		props: {},
		data() {
			return {
				form: {
					type: "电",
					dataType: '日',
					dataTime: new Date(),
				},
				dateType: 'date',
				timeFormat: "yyyy-MM-dd",
				unit: "Kwh",
				dataTable: [],
				appType: 36,
				tableColumn: [],
				option1: {
					title: {
						text: '分项用能趋势',
						textStyle: {
							color: "#ffffff",
						},
						left: '40px',
						top: "20px",
					},
					xAxis: {
						type: 'category',
						splitLine: {
							show: false
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#ffffff'
							}
						},
						axisTick: {
							show: false
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "#0774af",
							}
						},
						data: []
					},
					grid: {
						left: "4%",
						right: "2%",
					},
					legend: {
						icon: "circle",
						bottom: '0',
						textStyle: {
							color: '#ffffff',
						},
						data: []
					},
					yAxis: {
						type: 'value',
						splitLine: {
							lineStyle: {
								color: "#0774af",
								type: 'dashed'
							}
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#ffffff'
							}
						},
						axisTick: { //y轴刻度线
							show: true
						},
						axisLine: { //y轴
							show: false
						},
					},
					series: []
				},
				countAmout: 0,
				countTbAmout: 0,
				subAreausList: {},
				getTbType: '昨日',
			}
		},
		created() {},
		mounted() {
			this.$refs.vchart1.setData(this.option1)
			this.initData()
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			getProp() {
				return(i) => {
					return "value" + i
				}
			},
			gettb() {
				return(data1, data2) => {
					let value = 0
					if(data1 != 0 && data2 != 0) {
						value = ((data1 - data2) / data2 * 100).toFixed(2)
					}
					return value
				}
			},
			getDiscount() {
				let value = 0
				let coefficient = 0
				switch(this.form.type) {
					case '电':
						coefficient = 0.1229
						break;
					case '水':
						coefficient = 0.0857
						break;
					case '气':
						coefficient = 1.2143
						break;
				}
				if(!isempty(this.countAmout)) {
					value = (this.countAmout * coefficient).toFixed(2)
				}
				return value
			},
			getCountTbAmout() {
				let value = 0
				if(this.countTbAmout != 0 && this.countAmout != 0) {
					value = ((this.countAmout - this.countTbAmout) / this.countTbAmout * 100).toFixed(2)
				}
				return value
			},
			getunitAreaAmount() {
				return(this.countAmout / this.nowUnit.unitArea).toFixed(2)
			},
			getPeopleAmount() {
				return(this.countAmout / this.nowUnit.unitPeopleNumber).toFixed(2)
			},
			getImage() {
				return img => {
					return resourcesStore.getters.getResourcesByName('energyEfficiencySystem/statistics/' + img)
				}
			},
			getArrowImage() {
				return value => {
					let img = ""
					value >= 0 ? img = "1.png" : img = "2.png"
					return this.getImage(img)
				}
			}
		},
		watch: {
			'form.dataType': {
				deep: true,
				handler(nv, ov) {
					switch(nv) {
						case "日":
							this.dateType = "date"
							this.timeFormat = "yyyy-MM-dd"
							this.getTbType = "昨日"
							break;
						case "周":
							this.dateType = "week"
							this.timeFormat = "yyyy 第 WW 周"
							this.getTbType = "上周"
							break;
						case "月":
							this.dateType = "month"
							this.timeFormat = "yyyy-MM"
							this.getTbType = "上月"
							break;
						case "年":
							this.dateType = "year"
							this.timeFormat = "yyyy"
							this.getTbType = "上年"
							break;
					}
					this.initData()
				}
			},
			'form.type': {
				deep: true,
				handler(nv, ov) {
					switch(nv) {
						case "电":
							this.unit = "Kwh"
							this.appType = 36
							break;
						case "水":
							this.unit = "m³"
							this.appType = 237
							break;
						case "气":
							this.unit = "Nm³"
							this.appType = 361
							break;
					}
					this.initData()
				}
			},
			'form.dataTime': {
				deep: true,
				handler(nv, ov) {
					this.initData()
				}
			},
			nowUnit(nv, ov) {
				this.initData()
			}
		},
		methods: {
			initData() {
				if(isempty(this.nowUnit.id)) {
					return
				}
				//开始时间和结束时间
				let bgTime = new Date()
				let endTime = new Date()
				let lasBgTime = new Date() //同比开始日期
				let lasEndTime = new Date() //同比结束日期
				let bghms = " 00:00:00"
				let endhms = " 23:59:59"
				switch(this.form.dataType) {
					case "日":
						bgTime = new Date(this.form.dataTime.format("yyyy-MM-dd") + bghms).getTime()
						endTime = new Date(this.form.dataTime.format("yyyy-MM-dd") + endhms).getTime()
						lasBgTime = new Date(bgTime - (1000 * 60 * 60 * 24)).getTime()
						lasEndTime = new Date(endTime - (1000 * 60 * 60 * 24)).getTime()
						break;
					case "周":
						let dateArray = getWeekStartAndEnd(0, this.form.dataTime)
						bgTime = new Date(dateArray[0] + bghms).getTime()
						endTime = new Date(dateArray[1] + endhms).getTime()
						//同比日期
						let lasDateArray = getWeekStartAndEnd(-1, this.form.dataTime)
						lasBgTime = new Date(lasDateArray[0] + bghms).getTime()
						lasEndTime = new Date(lasDateArray[1] + endhms).getTime()
						break;
					case "月":
						let monthDateArray = getMonthStartAndEnd(0, this.form.dataTime)
						bgTime = new Date(monthDateArray[0] + bghms).getTime()
						endTime = new Date(monthDateArray[1] + endhms).getTime()
						//同比日期
						let monthLasDateArray = getMonthStartAndEnd(-1, this.form.dataTime)
						lasBgTime = new Date(monthLasDateArray[0] + bghms).getTime()
						lasEndTime = new Date(monthLasDateArray[1] + endhms).getTime()
						break;
					case "年":
						bgTime = new Date(this.form.dataTime.format("yyyy") + "-01-01" + bghms).getTime()
						endTime = new Date(this.form.dataTime.format("yyyy") + "-12-31" + bghms).getTime()
						//同比日期
						let lasYear = this.form.dataTime.format("yyyy") - 1
						lasBgTime = new Date(lasYear + "-01-01" + bghms).getTime()
						lasEndTime = new Date(lasYear + "-12-31" + bghms).getTime()
						break;
				}
				this.$api.areausePower.getStatistics(this.nowUnit.id, this.appType, this.form.dataType, bgTime, endTime, lasBgTime, lasEndTime, respon => {
					if(!isempty(respon)) {
						this.countAmout = respon.countAmout
						this.countTbAmout = respon.countTbAmout
						this.subAreausList = respon.subAreausList
						this.tableColumn = respon.xData
						//图形数据
						this.option1.xAxis.data = respon.xData
						this.option1.series = []
						this.option1.legend.data = []
						this.dataTable = []
						for(let key in respon.barData) {
							this.option1.series.push({
								name: key,
								type: "bar",
								stack: '用' + this.form.type,
								data: respon.barData[key]
							})
							let obj = {
								name: key
							}
							respon.barData[key].forEach((item, i) => {
								obj['value' + i] = item
							})
							this.dataTable.push(obj)
							this.option1.legend.data.push(key)
						}
						this.$refs.vchart1.setData(this.option1)
					}
				})
			}
		}
	}
</script>

<style scoped>
	.iEcanalysisBody {
		width: 100%;
		height: 100%;
		background-color: #11173c;
	}
	
	.iEcanalysisBody .top {
		width: 100%;
		height: 8%;
		display: flex;
		align-items: center;
	}
	
	.iEcanalysisBody .center,
	.center2 {
		width: 100%;
		height: 11%;
		display: flex;
		align-items: center;
		overflow: overlay;
	}
	
	.iEcanalysisBody .center2_div {
		width: 15%;
		height: 95%;
		margin-left: 2%;
		background-color: #082d76;
		border-radius: .05rem;
		border: .01rem solid #045ae8;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	
	.iEcanalysisBody .center2_div div {
		width: 90%;
		height: 50%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.iEcanalysisBody .center2_div div:nth-child(1) {
		border-bottom: .01rem solid #0263ff;
	}
	
	.iEcanalysisBody .center2_div div:nth-child(2) {
		border-top: .01rem solid #0263ff;
	}
	
	.iEcanalysisBody .center2_div div span {
		color: white;
		font-size: .18rem;
	}
	
	.iEcanalysisBody .center_div {
		width: 17%;
		height: 95%;
		background-color: #082d76;
		border-radius: .05rem;
		border: .01rem solid #045ae8;
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin-left: 2%;
	}
	
	.iEcanalysisBody .center_div img {
		width: .6rem;
		height: .6rem;
		padding-left: .1rem;
	}
	
	.iEcanalysisBody .center_div div {
		width: 55%;
		height: 55%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	
	.iEcanalysisBody .center_div p {
		color: white;
		font-size: .18rem;
	}
	
	.iEcanalysisBody .subtitle {
		display: flex;
		align-items: center;
		width: 97.5%;
		height: 5%;
		margin-left: 2%;
	}
	
	.iEcanalysisBody .subtitle h1 {
		font-size: .16rem;
		color: white;
	}
	
	.iEcanalysisBody .bottom {
		width: 100%;
		height: 40%;
	}
	
	.iEcanalysisBody .default-chart {
		height: 100%;
	}
	
	.iEcanalysisBody .bottom_table {
		width: 100%;
		height: 25%;
	}
</style>
<style>
	.iEcanalysisBody .el-form-item {
		margin-bottom: 0;
		margin-left: .2rem;
	}
	
	.iEcanalysisBody .el-form {
		display: flex;
	}
	.iEcanalysisBody label{
		color: white;
	}
	/*表格样式*/
	.iEcanalysisBody .el-table {
		width: 100%;
		height: 100%;
		background-color: #11173c;
	}
	
	.iEcanalysisBody .el-table th {
		background-color: #082d76;
		color: white;
		border: 0;
	}
	
	.iEcanalysisBody .el-table th:nth-child(1) {
		color: #0aa4e9;
	}
	
	.iEcanalysisBody .el-table td {
		background-color: #11173c;
		color: white;
		border: 0;
		border-top: .01rem solid #0774af;
	}
	.iEcanalysisBody .el-table td:nth-child(1) {
		color: #0aa4e9;
	}
	
	.iEcanalysisBody .el-table tr:hover>td {
		background-color: #00456b;
	}
	.iEcanalysisBody .el-table__body .el-table__row.hover-row td {
		background-color: #00456b !important;
	}
	.iEcanalysisBody .el-input__inner{
		background-color: #11173c;
		border: 1px solid #0775a5;
		color: white;
	}
	.iEcanalysisBody .el-radio-group {
		margin-left: .2rem;
		background-color: #11173c;
	}
	.iEcanalysisBody .el-radio-button__inner{
		background-color: #11173c;
		border: 1px solid #0775a5;
		color: white;
	}
	.iEcanalysisBody .el-radio-button:first-child .el-radio-button__inner{
		border-left: 1px solid #0775a5;
	}
</style>